import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton } from '../common/Buttons';
import './style.css';

const plans = [
  {
    title: '🚀 STARTER',
    monthlyPrice: 29.99,
    annualPrice: 299.99,
    description: 'For small businesses.',
    features: [
      '1 website',
      '10 GB storage',
      'monthly backups',
      'SSL & CDN included',
      'Standard support',
      'NET 30: Not available',
    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/28E28s5qRavKaz29ee2wU00',
    annualLink: 'https://payments.sjsocialmedia.com/b/28E7sM3iJ8nCgXqbmm2wU01',
  },
  {
    title: '⚙️ PRO',
    monthlyPrice: 59.99,
    annualPrice: 599.99,
    description: 'For growing businesses.',
    features: [
      '1 website',
      '15 GB storage',
      'weekly backups',
      'SSL & CDN included',
      'Priority support',
      'Advanced security',
      'NET 30: Available with validation',
    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/3cI9AU1aBcDScHa9ee2wU02',
    annualLink: 'https://payments.sjsocialmedia.com/b/aFa4gA06x7jy6iM3TU2wU03',
    featured: true,
  },
  {
    title: '🛒 COMMERCE',
    monthlyPrice: 119.99,
    annualPrice: 1199.99,
    description: 'For online stores.',
    features: [
      '1 website',
      '20 GB storage',
      'Daily backups + monitoring',
      'SSL & CDN included',
      'WooCommerce ready',
      '24/7 premium support',
      'Advanced security',
      'NET 30: Available with contract',
    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/dRm6oI5qR33igXqcqq2wU04',
    annualLink: 'https://payments.sjsocialmedia.com/b/28E8wQ8D3cDS9uYbmm2wU05',
  },
  {
    title: '🧩 CUSTOM',
    monthlyPrice: 0,
    annualPrice: 0,
    description: 'Tailored for complex.',
    features: [
      'Scalable architecture',
      'Dedicated resources',
      'Advanced integrations',
      'Custom technical support',
      'NET 30: Available upon approval',
    ],
    monthlyLink: './contact',
    annualLink: './contact',
  },
];

function PlansSection({ id }) {
  const [isAnnual, setIsAnnual] = useState(false);

  const handleToggle = () => {
    setIsAnnual(prev => !prev);
  };

  return (
    <section className="plans-section" id={id || "hosting-plans"}>
      <Container>
        <div className="text-center mb-4">
          <h2 className="plans-title">
            Choose the plan that’s yours
          </h2>
          <div className="plans-lead">
            Cancel anytime · Money-back guarantee
          </div>
          <div className="plans-toggle">
            <span className="plans-toggle-label">Bill Monthly</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={isAnnual}
                onChange={handleToggle}
              />
              <span className="slider round"></span>
            </label>
            <span className="plans-toggle-label">Bill Annually</span>
          </div>
        </div>
        <Row>
          {plans.map((plan, index) => (
            <Col md="6" lg="3" className="mb-4" key={index}>
              <div
                className={
                  "plan-card" +
                  (plan.featured ? " plan-card-featured" : "")
                }
                tabIndex={0}
                aria-label={plan.title + (plan.featured ? " (Featured)" : "")}
              >
                {plan.featured && (
                  <div className="plan-featured-badge">★ Featured</div>
                )}
                <div>
                  <h6 className="plan-title">{plan.title}</h6>
                  <div className="plan-desc">{plan.description}</div>
                  <div className="plan-price">
                    {plan.monthlyPrice === 0
                      ? 'Custom'
                      : `$${isAnnual ? plan.annualPrice.toFixed(2) : plan.monthlyPrice.toFixed(2)}`}
                  </div>
                  <ul className="plan-features">
                    {plan.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </div>
                <div className="plan-btn">
                  <PrimaryButton
                    href={isAnnual ? plan.annualLink : plan.monthlyLink}
                  >
                    {plan.monthlyPrice === 0 ? 'Contact Sales' : 'Get Started'}
                  </PrimaryButton>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default PlansSection;
